import { useState } from 'react'
import type { ArtefactTemplate } from '../../../types/artefact-templates'

interface UseManagerOptions {
  onDelete: (templateId: string) => Promise<boolean>
  onRefetch: () => void
}

interface ManagerState {
  modalOpen: boolean
  editingTemplate: ArtefactTemplate | null
  deleteConfirm: string | null
  openCreateModal: () => void
  openEditModal: (template: ArtefactTemplate) => void
  closeModal: () => void
  handleSaved: () => void
  requestDelete: (templateId: string) => void
  cancelDelete: () => void
  confirmDelete: (templateId: string) => Promise<void>
}

export function useArtefactTemplateManager({
  onDelete,
  onRefetch,
}: UseManagerOptions): ManagerState {
  const [modalOpen, setModalOpen] = useState(false)
  const [editingTemplate, setEditingTemplate] = useState<ArtefactTemplate | null>(null)
  const [deleteConfirm, setDeleteConfirm] = useState<string | null>(null)

  return {
    modalOpen,
    editingTemplate,
    deleteConfirm,
    openCreateModal: () => {
      setEditingTemplate(null)
      setModalOpen(true)
    },
    openEditModal: (template) => {
      setEditingTemplate(template)
      setModalOpen(true)
    },
    closeModal: () => {
      setModalOpen(false)
      setEditingTemplate(null)
    },
    handleSaved: () => {
      setModalOpen(false)
      setEditingTemplate(null)
      onRefetch()
    },
    requestDelete: (templateId) => {
      setDeleteConfirm(templateId)
    },
    cancelDelete: () => {
      setDeleteConfirm(null)
    },
    confirmDelete: async (templateId) => {
      const success = await onDelete(templateId)
      if (success) {
        setDeleteConfirm(null)
        onRefetch()
      }
    },
  }
}
